import { render, staticRenderFns } from "./AnnualReportsList.vue?vue&type=template&id=13e0e536&scoped=true&"
import script from "./AnnualReportsList.vue?vue&type=script&lang=js&"
export * from "./AnnualReportsList.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReportsList.vue?vue&type=style&index=0&id=13e0e536&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e0e536",
  null
  
)

export default component.exports